import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, output } from '@angular/core';
import { WooComponentsModule } from '@scripts/woo_components.module/module';
import { AdOrganisation, CompactAgency } from '@scripts/woo_services.module/shared-types';
import { VoucherParams } from '@scripts/woo_services.module/VoucherService';
import { BaseModalComponent } from '@src/shared/modal/base-modal/base-modal.component';
import { ModalLayoutComponent } from '@src/shared/modal/base-modal/modal-layout/modal-layout.component';

@Component({
  selector: 'app-new-discount-modal',
  imports: [CommonModule, ModalLayoutComponent, WooComponentsModule],
  templateUrl: './new-discount-modal.component.html',
  styleUrl: './new-discount-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NewDiscountModalComponent extends BaseModalComponent<{
  agencies: CompactAgency[];
  adOrganisations: AdOrganisation[];
}> {
  readonly agencies = computed(() => this.modaldata()?.agencies ?? []);
  readonly adOrganisations = computed(() => this.modaldata()?.adOrganisations ?? []);
  submit = output<VoucherParams>();
}
